import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';
import { useOnlineStatus } from '@/hooks';
import { useSetAtom } from 'jotai';
import { demoModeAtom, videoPanelOpenAtom } from '@/store';

export function WifiIndicator() {
  const isOnline = useOnlineStatus();
  const setDemoMode = useSetAtom(demoModeAtom);
  const setVideoPanelOpen = useSetAtom(videoPanelOpenAtom);

  const handleClick = () => {
    setDemoMode(true);
    setVideoPanelOpen(true);
  };

  return (
    <Tooltip title={isOnline ? 'Online' : 'Offline'}>
      <IconButton onClick={handleClick} sx={{ color: 'white' }}>
        {isOnline ? <WifiIcon /> : <WifiOffIcon />}
      </IconButton>
    </Tooltip>
  );
}
